import SuggestionItem from './SuggestionItem'

export default SuggestionItem



// WEBPACK FOOTER //
// ./src/components/Form/components/AutoCompleteInput/components/SuggestionItem/index.js